import { IJsonPatch, tryResolve, getParent, isArrayType, isType, getPath, getSnapshot, isStateTreeNode, getType } from "@invisr/mobx-state-tree"
import type { IStore } from "../store/store"

export default (updates: IJsonPatch[], store: IStore) : IJsonPatch[] => {
  try {
    let result = replaceArrayItemRemoveWithEntireArrayUpdate(updates, store)
    return result
  } catch (err) {
    console.log(err)
    return updates
  }
}

/*
* patches are debounced and come in batches. When the user removes 1st array item
* and then again removes 1st array item, the batch has 'remove /0' path twice (which is wrong).
* to fix that, whenever an array item gets removed, update the entire array instead.
*/
const replaceArrayItemRemoveWithEntireArrayUpdate = (updates: IJsonPatch[], store: IStore) : IJsonPatch[] => {

    // get all arrays where some item.op === 'remove'
    const arraysToUpdate = {}
    for (const patch of updates) {
      let node
      try {
        node = tryResolve(store, patch.path) 
      } catch (e) {}
      if (!isStateTreeNode(node)) continue;
      const parentNode = getParent(node)
      const parentPath = getPath(parentNode)

      if (patch.op === 'remove' && isArrayType(getType(parentNode)) && isStateTreeNode(parentNode)) {
        // check if there already is /a/b array patch when this is a/b/c patch
        const higherLevelArrayExists = Object.keys(arraysToUpdate).some(p => parentPath.startsWith(p))
        
        // remove all higher level arrays if needed (remove /a/b/c and /a/b/d when we this is a/b patch)
        Object.keys(arraysToUpdate).filter(p => p !== parentPath && p.startsWith(parentPath)).forEach(p => delete arraysToUpdate[p])

        if (!higherLevelArrayExists) {
          arraysToUpdate[parentPath] = { op: 'replace', path: parentPath, value: getSnapshot(parentNode) }
        }
      }
    }

    const result = updates.filter(patch => !Object.keys(arraysToUpdate).some(p => patch.path.startsWith(p)))
    result.push(...Object.values<IJsonPatch>(arraysToUpdate))
    
    return result
}